// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip_tooltip__WdRjq","arrow":"tooltip_arrow__AhFmB"};